// extracted by mini-css-extract-plugin
export default {"nav":"NavMenu_nav__dorV1","names":"NavMenu_names__F1f0e","menuLink":"NavMenu_menuLink__jsj-t","active":"NavMenu_active__sQ+6V"};